import React from "react";
import { CHIP_LABEL, type CardChipKind } from "../lib/cardState";
import "../styles/cards.css";

export interface CardStatusChipProps {
  kind: CardChipKind;
  className?: string;
}

/**
 * Status chip atom — the one place the "In hand / Active / Armed / Played /
 * Expired / Owned / Game card" vocabulary is rendered. Expired-only tiles read
 * "Expired", never "Owned". Colour comes from the shared status tokens.
 */
export default function CardStatusChip({ kind, className }: CardStatusChipProps) {
  return (
    <span
      className={["card-status-chip", `card-status-chip--${kind}`, className || ""]
        .filter(Boolean)
        .join(" ")}
    >
      {CHIP_LABEL[kind]}
    </span>
  );
}
